import React, { Component } from "react";
import { Link } from "react-router-dom";
import Social from "../section-components/social";
// api klasöründen settingsRepo'yu import et
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
class Navbar extends Component {
  render() {
    const { lang, setLang, settings, contact, category, loading } =
      this.props.appData;
    const categories = Array.isArray(category?.categories)
      ? category.categories
      : [];
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <div>
        <header className="ltn__header-area ltn__header-5 ltn__header-transparent--- gradient-color-4---">
          <div className="ltn__header-top-area section-bg-6 top-area-color-white---">
            <div className="container">
              <div className="row">
                <div className="col-md-7">
                  <div className="ltn__top-bar-menu">
                    <ul>
                      <li>
                        <a
                          href={`mailto:${
                            contact?.email1 || "info@safkar.com"
                          }`}
                        >
                          <i className="icon-mail" />{" "}
                          {contact?.email1 || "info@safkar.com"}
                        </a>
                      </li>
                      <li>
                        <a
                          href={`tel:${contact?.phone1 || "+90 000 000 0000"}`}
                        >
                          <i className="icon-placeholder" />{" "}
                          {contact?.phone1 || "+90 000 000 0000"}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="top-bar-right text-end">
                    <div className="ltn__top-bar-menu">
                      <ul>
                        <li>
                          {/* Language Toggle Button */}
                          <button
                            type="button"
                            onClick={() => setLang(lang === "tr" ? "en" : "tr")}
                            style={{
                              background: "none",
                              border: "none",
                              color: "inherit",
                              cursor: "pointer",
                              font: "inherit",
                              padding: "5px 10px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {lang === "tr" ? "Türkçe" : "English"}
                            <i
                              className="fa fa-check"
                              style={{ fontSize: "12px" }}
                            ></i>
                          </button>
                        </li>
                        <li>
                          <Social />
                        </li>
                        <li>
                          {/* header-top-btn */}
                          <div className="header-top-btn">
                            <a
                              href="https://b2b.safkar.com/login.aspx"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {lang === "en" ? "Dealer Login" : "Bayi Girişi"}
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="site-logo-wrap">
                    <div className="site-logo go-top">
                      <Link to="/">
                        {!loading && settings?.logo && (
                          <img src={API_FILE_URL + settings.logo} alt="Logo" />
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col header-menu-column">
                  <div className="header-menu d-none d-xl-block">
                    <nav>
                      <div className="ltn__main-menu go-top">
                        <ul>
                          <li>
                            <Link to="/kurumsal">
                              {lang === "tr" ? "Kurumsal" : "Corporate"}
                            </Link>
                          </li>
                          <li className="menu-icon">
                            <Link to="/urunler">
                              {lang === "tr" ? "Ürünler" : "Products"}
                            </Link>
                            <ul>
                              {categories.map((cat, i) => {
                                const t = cat.translations?.[lang] || {};
                                return (
                                  <li key={i}>
                                    <Link
                                      to={{
                                        pathname: "/urunler",
                                        state: { categoryId: cat.id },
                                      }}
                                    >
                                      {t?.name || ""}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </li>
                          <li>
                            <Link to="/satis-servis">
                              {lang === "tr"
                                ? "Satış & Servis"
                                : "Sales & Service"}
                            </Link>
                          </li>
                          <li>
                            <Link to="/haberler">
                              {lang === "tr" ? "Haberler" : "News"}
                            </Link>
                          </li>
                          <li>
                            <Link to="/iletisim">
                              {lang === "tr" ? "İletişim" : "Contact"}
                            </Link>
                          </li>
                          <li>
                            <Link to="/yatirimci-iliskileri">
                              {lang === "tr"
                                ? "Yatırımcı İlişkileri"
                                : "Investor Relations"}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </nav>
                  </div>
                </div>
                <div className="col mobile-menu-toggle d-xl-none">
                  <a
                    href="#ltn__utilize-mobile-menu"
                    className="ltn__utilize-toggle"
                  >
                    <i className="fas fa-bars"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div
          id="ltn__utilize-mobile-menu"
          className="ltn__utilize ltn__utilize-mobile-menu"
        >
          <div className="ltn__utilize-menu-inner ltn__scrollbar">
            <div className="ltn__utilize-menu-head">
              <div className="site-logo">
                <Link to="/">
                  {!loading && settings?.logo && (
                    <img src={API_FILE_URL + settings.logo} alt="Logo" />
                  )}
                </Link>
              </div>
              <button className="ltn__utilize-close">×</button>
            </div>
            <div className="ltn__utilize-menu">
              <ul>
                <li>
                  <Link to="/kurumsal">
                    {lang === "tr" ? "Kurumsal" : "Corporate"}
                  </Link>
                </li>
                <li>
                  <Link to="/urunler">
                    {lang === "tr" ? "Ürünler" : "Products"}
                  </Link>
                  <ul className="sub-menu">
                    {categories.map((cat, i) => {
                      const t = cat.translations?.[lang] || {};
                      return (
                        <li key={i}>
                          <Link
                            to={{
                              pathname: "/urunler",
                              state: { categoryId: cat.id },
                            }}
                          >
                            {t?.name || ""}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
                <li>
                  <Link to="/satis-servis">
                    {lang === "tr" ? "Satış & Servis" : "Sales & Service"}
                  </Link>
                </li>
                <li>
                  <Link to="/haberler">
                    {lang === "tr" ? "Haberler" : "News"}
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim">
                    {lang === "tr" ? "İletişim" : "Contact"}
                  </Link>
                </li>
                <li>
                  <Link to="/yatirimci-iliskileri">
                    {lang === "tr"
                      ? "Yatırımcı İlişkileri"
                      : "Investor Relations"}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppData(Navbar);
